import { render, staticRenderFns } from "./ShiftClotsMultiForm.vue?vue&type=template&id=235319bc&"
import script from "./ShiftClotsMultiForm.vue?vue&type=script&lang=ts&"
export * from "./ShiftClotsMultiForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports